import React, { useRef, useState } from 'react';

import { BACKEND_BASE_URL } from '../../../../config';
import {
  AiChatButton,
  ButtonChat,
  CompanyInfoElements,
  CompanyInformationContainer,
  LeftCol,
  LogoPriceContainer,
  LogoResultContainer,
  PriceContainer,
  PriceResult,
  QuoteInformationResultContainer,
  QuoteInformationResultItem,
  RiskCardSelectedStyles,
} from '../ResultPageComponents/v2/SelectedQuoteCard.styles';
import CasaInfoModal from '../Modal/CasaInfoModal';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';
import SparklesIcon from '../../../../assets/images/icons/SparklesIcon';
import { Chat } from '../../chats/MiniChat/MiniChat';
import { monopattiniPackage, stringToPrice } from '../../../constants';
import RiskCompanyInfoComponent from './riskCardReusable/RiskCompanyInfoComponent';
import ModalsImported from './riskCardReusable/ModalsImported';

function RiskCardSelected({
  quote, type, requestInfo, professionId = null,
}) {
  const [showModal, setShowModal] = useState(false);
  const [openChat, setOpenChat] = useState(false);
  const chatRef = useRef();

  // Same "Maggiori Informazioni" info-modal state as the modal's RiskCard
  // (ModalsImported / openModal+openModalEurope below) — kept separate from
  // the Casa-only showModal/openModal above, which predates this and is only
  // ever used for CasaInfoModal.
  const [showModalAssistenza, setShowModalAssistenza] = useState(false);
  const [showModalGlobalTutela, setShowModalGlobalTutela] = useState(false);
  const [showModalGlobalInfortuni, setShowModalGlobalInfortuni] = useState(false);
  const [showModalGlobalCristalli, setShowModalGlobalCristalli] = useState(false);
  const [showModalEuropeAssistenza, setShowModalEuropeAssistenza] = useState(false);
  const [showModalEuropeTutela, setShowModalEuropeTutela] = useState(false);
  const [showModalEuropeCristalli, setShowModalEuropeCristalli] = useState(false);
  const [showModalEuropeCollisione, setShowModalEuropeCollisione] = useState(false);
  const [showModalTutelaArag, setShowModalTutelaArag] = useState(false);
  const [showModalGlobalTutelaProduct, setShowModalGlobalTutelaProduct] = useState(false);

  const openModal = () => {
    setShowModal(!showModal);
  };

  const openInfoModal = () => {
    if (quote.quote_type === 'assistenza_stradale') {
      setShowModalAssistenza(!showModalAssistenza);
    }
    if (quote.quote_type === 'tutela_legale' && quote.company_id === 16) {
      setShowModalGlobalTutela(!showModalGlobalTutela);
    }
    if (quote.quote_type === 'tutela_legale' && quote.company_id === 15) {
      setShowModalTutelaArag(!showModalTutelaArag);
    }
    if (quote.quote_type === 'infortuni_conducente') {
      setShowModalGlobalInfortuni(!showModalGlobalInfortuni);
    }
    if (quote.quote_type === 'cristalli') {
      setShowModalGlobalCristalli(!showModalGlobalCristalli);
    }
    if (quote.product_id === 9 && quote.company_id === 16 && quote.sub_product === 'vita_privata') {
      setShowModalGlobalTutelaProduct(!showModalGlobalTutelaProduct);
    }
  };

  const openInfoModalEurope = () => {
    if (quote.quote_type === 'assistenza_stradale') {
      setShowModalEuropeAssistenza(!showModalEuropeAssistenza);
    }
    if (quote.quote_type === 'tutela_legale') {
      setShowModalEuropeTutela(!showModalEuropeTutela);
    }
    if (quote.quote_type === 'cristalli') {
      setShowModalEuropeCristalli(!showModalEuropeCristalli);
    }
    if (quote.quote_type === 'collisione') {
      setShowModalEuropeCollisione(!showModalEuropeCollisione);
    }
  };

  const extraText = ` ${(quote.risk_massimale !== null
    && quote.risk_massimale !== undefined
    && quote.risk_massimale != 0)
    || (quote.massimale !== null
      && quote.massimale !== undefined
      && quote.massimale != 0)
    ? `Massimale: ${quote.risk_massimale !== null
      && quote.risk_massimale !== undefined
      && quote.risk_massimale != 0
      ? quote.risk_massimale
      : quote.massimale !== null
        && quote.massimale !== undefined
        && quote.massimale != 0
        ? quote.massimale
        : ''
    }`
    : ''
  }  - Frequenza pagamento: ${quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'
  } ${requestInfo?.commercial_company?.activity_description
    ? `- Tipologia di attività commerciale : ${requestInfo?.commercial_company?.activity_description}` : ''
  }`;

  const getSubProductRisk = () => {
    if (quote.company_id === 1001 && quote.quote_type !== 'res_civile' && quote.product_id === 1) {
      return 'nobis_risk';
    }

    if (quote.company_id === 1005 && quote.product_id === 1) {
      if (quote.quote_type === 'tutela_legale') {
        return 'my_rescue_tutela';
      }

      if (quote.quote_type === 'collisione') {
        return 'my_rescue_collisione';
      }

      if (quote.quote_type === 'assistenza_stradale') {
        return 'my_rescue_assistenza';
      }
    }
    return null;
  };

  return (
    <RiskCardSelectedStyles
      className={quote.is_aquista === 1 ? 'selected' : ''}
    >
      <div className="row-container">
        <LeftCol>
          {quote.company_id === 1005 && quote.product_id === 1 && (
            <div className="alert alert-danger mt-1 mb-2 p-1">
              Servizio non assicurativo
            </div>
          )}
          {quote.company_id === 9 && requestInfo.payment_frequency === 2 && (
            <div className="alert alert-warning mt-1 mb-2 p-1 w-100">
              <b>Attenzione:</b>
              {' '}
              Linear non supporta il pagamento semestrale.
            </div>
          )}
          {quote.company_id === 18
            && requestInfo.payment_frequency === 2 && (
              <div className="alert alert-warning mt-1 mb-2 p-1 w-100">
                <b>Attenzione:</b>
                {' '}
                Genial Piu non supporta il pagamento semestrale.
              </div>
          )}
          <LogoPriceContainer>
            <LogoResultContainer>
              <img
                src={BACKEND_BASE_URL + quote.company.logo}
                alt={quote.company.name}
              />
            </LogoResultContainer>
            {quote.amount != 0 && (
              <PriceContainer>
                <PriceResult>
                  <h5>Prezzo annuo:</h5>
                  <h2>
                    &euro;
                    {parseFloat(quote.amount).toFixed(2)}
                  </h2>
                </PriceResult>
                {quote.payment_frequency === 2 && (
                  <PriceResult>
                    <h5>Prezzo Semestrale:</h5>
                    <h6>Primo Pagamento</h6>
                    <h2>
                      &euro;
                      {(
                        Number(quote.amount) / quote.payment_frequency
                      ).toLocaleString('it-IT', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </h2>
                  </PriceResult>
                )}
              </PriceContainer>
            )}
          </LogoPriceContainer>
          {/* <CompanyInformationContainer>
            {quote.quote_type === 'tutela_legale' && (
              <>
                <CompanyInfoElements
                  onClick={() => downloadResourceDocs(10, 0)}
                  title="questionario_pi_tutela_legale"
                >
                  <img src={preventiveIcon} alt="" />
                  <p>Questionario</p>
                </CompanyInfoElements>
                <CompanyInfoElements
                  onClick={() => downloadResourceDocs(9, 0)}
                  title="set_informativo_pi_Tutela_legale"
                >
                  <img src={preContractIcon} alt="" />
                  <p>Informativa Precontrattuale</p>
                </CompanyInfoElements>
              </>
            )}
          </CompanyInformationContainer> */}

          {showModal && quote.company_id == 8 && quote.product_id == 11 && (
            <CasaInfoModal setShowModal={setShowModal} quote={quote} />
          )}

          {quote.company_id === 8
            && quote.product_id === 11
            && quote.quote_type !== 'danni_elettrici_al_fabricato'
            && quote.quote_type !== 'danni_elettrici_contenuto' && (
              <CompanyInformationContainer>
                <CompanyInfoElements onClick={() => openModal()}>
                  <img src={infoIcon} alt="" />
                  <p>Maggiori informazioni</p>
                </CompanyInfoElements>
              </CompanyInformationContainer>
          )}

          {/* Same "Maggiori Informazioni"/Informativa Precontrattuale links
              (and the info modals they open) as the modal's RiskCard, for
              every quote_type/company_id combo it covers — assistenza_stradale,
              tutela_legale, infortuni_conducente, cristalli, collisione,
              vita_privata, plus the company 1001/product 1 doc link that used
              to be duplicated inline here above (removed, this covers it too) */}
          <RiskCompanyInfoComponent
            quote={quote}
            openModal={openInfoModal}
            openModalEurope={openInfoModalEurope}
          />
          <ModalsImported
            quote={quote}
            showModalAssistenza={showModalAssistenza}
            setShowModalAssistenza={setShowModalAssistenza}
            showModalGlobalTutela={showModalGlobalTutela}
            setShowModalGlobalTutela={setShowModalGlobalTutela}
            showModalGlobalInfortuni={showModalGlobalInfortuni}
            setShowModalGlobalInfortuni={setShowModalGlobalInfortuni}
            showModalGlobalCristalli={showModalGlobalCristalli}
            setShowModalGlobalCristalli={setShowModalGlobalCristalli}
            showModalEuropeAssistenza={showModalEuropeAssistenza}
            setShowModalEuropeAssistenza={setShowModalEuropeAssistenza}
            showModalEuropeTutela={showModalEuropeTutela}
            setShowModalEuropeTutela={setShowModalEuropeTutela}
            showModalEuropeCristalli={showModalEuropeCristalli}
            setShowModalEuropeCristalli={setShowModalEuropeCristalli}
            showModalEuropeCollisione={showModalEuropeCollisione}
            setShowModalEuropeCollisione={setShowModalEuropeCollisione}
            showModalTutelaArag={showModalTutelaArag}
            setShowModalTutelaArag={setShowModalTutelaArag}
            showModalGlobalTutelaProduct={showModalGlobalTutelaProduct}
            setShowModalGlobalTutelaProduct={setShowModalGlobalTutelaProduct}
          />

          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            {quote.company_id === 1001 && quote.product_id == 10 && (
              <QuoteInformationResultItem>
                <h6>Prodotto:</h6>
                <p>Commercio Su Misura</p>
              </QuoteInformationResultItem>
            )}
            {(quote.product_id === 1002 || quote.product_id === 1003) && (
              <QuoteInformationResultItem>
                <h6>Prodotto:</h6>
                <p>{requestInfo.product.name}</p>
              </QuoteInformationResultItem>
            )}
            {quote.product_id !== 1002 && quote.product_id !== 1003
              && (
                <QuoteInformationResultItem>
                  <h6>Prodotto:</h6>
                  {/* Always the guarantee's own name here — same as the
                      modal's RiskQuoteInfoComponent. quote.product_name (e.g.
                      "Pacchetto Gold") is a different thing, the specific
                      package/plan name, shown in its own "Nome Prodotto" row
                      below instead of overwriting this one. */}
                  <p>{type.name}</p>
                </QuoteInformationResultItem>
              )}

            {/* Same "Emissione" row the modal's RiskCompanyInfoComponent
                shows for every risk quote */}
            <QuoteInformationResultItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationResultItem>

            {((quote.risk_massimale !== null
              && quote.risk_massimale !== undefined
              && quote.risk_massimale != 0)
              || (quote.massimale !== null
                && quote.massimale !== undefined
                && quote.massimale != 0)) && (
                <QuoteInformationResultItem>
                  <h6>Massimale:</h6>
                  <p>
                    {quote.risk_massimale !== null
                      && quote.risk_massimale !== undefined
                      && quote.risk_massimale != 0
                      ? !String(quote.risk_massimale).includes('€')
                        ? stringToPrice(quote.risk_massimale)
                        : quote.risk_massimale
                      : quote.massimale !== null
                        && quote.massimale !== undefined
                        && quote.massimale != 0
                        ? !String(quote.massimale).includes('€')
                          ? stringToPrice(quote.massimale)
                          : quote.massimale
                        : ''}
                  </p>
                </QuoteInformationResultItem>
            )}

            {/* Same generic "Nome Prodotto" row as the modal's
                RiskQuoteInfoComponent. product_id 1002/1003 are excluded here
                too (not just 1002 like the modal) because RiskCardSelected
                already has its own combined 1002-or-1003 case for this same
                row further below — this just covers everything else. */}
            {quote.product_id !== 10
              && quote.product_id !== 11
              && quote.product_id !== 1002
              && quote.product_id !== 1003
              && quote.product_name && (
                <QuoteInformationResultItem>
                  <h6>Nome Prodotto:</h6>
                  <p>{quote.product_name}</p>
                </QuoteInformationResultItem>
            )}

            {quote.quote_type === 'adattamento_abitazione_malattia'
              && (
                <QuoteInformationResultItem>
                  <h6>Massimale:</h6>
                  <p>
                    5.000,00
                    {' '}
                    &euro;
                  </p>
                </QuoteInformationResultItem>
              )}
            {quote.quote_type === 'indennita_sostitutiva_malattia'
              && (
                <QuoteInformationResultItem>
                  <h6>Massimale:</h6>
                  <p>
                    100,00 &euro;/giorno per 100 giorni
                  </p>
                </QuoteInformationResultItem>
              )}
            {quote.quote_type === 'daria_da_convalescenza_malattia'
              && (
                <QuoteInformationResultItem>
                  <h6>Massimale:</h6>
                  <p>
                    100,00 &euro;/giorno per 20 giorni
                  </p>
                </QuoteInformationResultItem>
              )}

            {quote.quote_type === 'rsm_post_ricovero_malattia'
              && (
                <QuoteInformationResultItem>
                  <h6>Visite specialistiche ed esami diagnostici: </h6>
                  <p>
                    5.000,00 €
                  </p>
                </QuoteInformationResultItem>
              )}
            {quote.quote_type === 'rsm_post_ricovero_malattia'
              && (
                <QuoteInformationResultItem>
                  <h6>Terapie oncologiche:</h6>
                  <p>
                    5.000,00 €
                  </p>
                </QuoteInformationResultItem>
              )}
            {quote.quote_type === 'assistenza_post_infortunio'
              && (
                <QuoteInformationResultItem>
                  <h6>Massimale:</h6>
                  <p>
                    1.000,00 €
                  </p>
                </QuoteInformationResultItem>
              )}
            {quote.quote_type === 'adattamento_abitazione_veicolo_infortunio'
              && (
                <QuoteInformationResultItem>
                  <h6>Massimale:</h6>
                  <p>
                    5.000,00 €
                  </p>
                </QuoteInformationResultItem>
              )}
            {quote.quote_type === 'rsm_post_infortunio'
              && (
                <QuoteInformationResultItem>
                  <h6>Massimale:</h6>
                  <p>
                    3.000,00 €
                  </p>
                </QuoteInformationResultItem>
              )}
            {quote.quote_type === 'tutela_legale_vita_privata' && (
              <>
                <QuoteInformationResultItem>
                  <h6>Incluso:</h6>
                  <p>Cyber Risk 25€</p>
                </QuoteInformationResultItem>
                <QuoteInformationResultItem>
                  <h6>Incluso:</h6>
                  <p>Animali Domestici 19.99€</p>
                </QuoteInformationResultItem>
              </>
            )}

            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>

            {quote.quote_type === 'invalidita_permanente_da_infortunio' && quote.product_id === 1000 && (

              <QuoteInformationResultItem>
                <h6>Franchigia:</h6>
                <p>
                  3%
                </p>
              </QuoteInformationResultItem>

            )}

            {quote.quote_type === 'tutela_legale' && quote.product_id === 1000 && (

              <QuoteInformationResultItem>
                <h6>Scoperto:</h6>
                <p>
                  10% con minimo di € 1.500,00
                </p>
              </QuoteInformationResultItem>
            )}

            {(quote.product_id == '1002' || quote.product_id == '1003') && (

              <QuoteInformationResultItem>
                <h6>Nome Prodotto:</h6>
                <p>{quote.product_name}</p>
              </QuoteInformationResultItem>

            )}
            {quote.product_id == '11' && quote.company_id === 1001 && quote.quote_type === 'extra_incendio_contenuto' && (
              <>

                <QuoteInformationResultItem>
                  <h6>Massimale:</h6>
                  <p>
                    Tra &euro; 30,000 e &euro; 500,000
                  </p>
                </QuoteInformationResultItem>

              </>
            )}

            {quote.company_id === 1006 && quote.product_id === 1006 && (
              <>

                <QuoteInformationResultItem>
                  <h6>Paccheto:</h6>
                  <p>{monopattiniPackage.find((e) => e.id === quote.code).name}</p>
                </QuoteInformationResultItem>
              </>
            )}

            {quote.product_id === 1 && quote.company_id === 1001 && quote.external_quote_data && (
              <>
                {quote.external_quote_data.scoperto_in_rete && (
                  <QuoteInformationResultItem>
                    <h6>Scoperto In Rete:</h6>
                    <p>{quote.external_quote_data.scoperto_in_rete}</p>
                  </QuoteInformationResultItem>
                )}
                {quote.external_quote_data.franchigia_in_rete && (
                  <QuoteInformationResultItem>
                    <h6>Franchigia In Rete:</h6>
                    <p>
                      {quote.external_quote_data.franchigia_in_rete}
                      {' '}
                      &euro;
                    </p>
                  </QuoteInformationResultItem>
                )}
                {quote.external_quote_data.scoperto_fuori_rete && (
                  <QuoteInformationResultItem>
                    <h6>Scoperto Fuori Rete:</h6>
                    <p>{quote.external_quote_data.scoperto_fuori_rete}</p>
                  </QuoteInformationResultItem>
                )}
                {quote.external_quote_data.franchigia_fuori_rete && (
                  <QuoteInformationResultItem>
                    <h6>Franchigia Fuori Rete:</h6>
                    <p>
                      {quote.external_quote_data.franchigia_fuori_rete}
                      {' '}
                      &euro;
                    </p>
                  </QuoteInformationResultItem>
                )}

              </>
            )}

          </QuoteInformationResultContainer>

          {/* {quote.quote_type == 'tutela_legale'
            && (
              <QuoteInformationResultContainer>
                <QuoteInformationResultItem>
                  <h6>Scoperto:</h6>
                  <p>
                    10% con minimo di € 1.500,00
                  </p>
                </QuoteInformationResultItem>

              </QuoteInformationResultContainer>
            )} */}

          <ButtonChat>
            <AiChatButton onClick={() => setOpenChat(true)}>
              <SparklesIcon width={24} height={24} />
              <span>Chiedi all'AI</span>
            </AiChatButton>
            <Chat
              ref={chatRef}
              openChat={openChat}
              setOpenChat={setOpenChat}
              company_id={quote.company_id}
              product_id={quote.product_id}
              quote_type={quote.quote_type}
              company_name={quote.company.name}
              extraText={extraText}
              professionId={professionId}
              sub_product={getSubProductRisk()}
            />
          </ButtonChat>
        </LeftCol>
        {/* <RightCol /> */}
      </div>
    </RiskCardSelectedStyles>
  );
}

export default RiskCardSelected;
